class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.initVariant();
  }

  initVariant () {
    this.updateOptions();
    this.updateMasterId();
    this.setVariantUnavailable();
  }

  onVariantChange() {
    this.initVariant();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  setVariantUnavailable() {
    this.variantData = this.getVariantData()
    let optionIndex = 0
    const optionChecked = []
    if (this.options.length > 1) {
      optionIndex = 1
      optionChecked.push(this.currentVariant.options[0])
    }
    const optionCheck = Array.from(this.querySelector(`.js-product-form-input[data-option="${optionIndex}"]`).querySelectorAll('input')).map((radio) => radio.value)
    optionCheck && optionCheck.forEach( option => {
      const variant = this.variantData.find((variant) => {
        return !variant.options.map((variantOption, index) => {
          return [...optionChecked, option][index] === variantOption;
        }).includes(false);
      });
      this.querySelector(`.js-product-form-input[data-option="${optionIndex}"]`).querySelector(`input[value="${option}"]`).classList.remove('disabled')
      if (variant && !variant.available) {
        this.querySelector(`.js-product-form-input[data-option="${optionIndex}"]`).querySelector(`input[value="${option}"]`).classList.add('disabled')
      }
    })
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.js-product-form-input'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    this.buttonEvent();
  }

  buttonEvent() {
    const button = document.querySelector('.js-button-video');
    if (!button) return;
    button.addEventListener('click', (e) => {
      const index = e.target.getAttribute('data-index');
      const dot = document.querySelector(`.img-product .slick-dots li:nth-child(${index})`)
      dot && dot.click()
    });
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}


class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    const overlayEl = document.querySelector('.js-menu-drawer-overlay')
    overlayEl && overlayEl.addEventListener('click', (event) => {
      this.closeMenuDrawer(event)
    })
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class CollectionScroll extends HTMLElement {
  constructor() {
    super();
    
    this.indexSection = this.getAttribute('data-index')
    this.handleCollection = this.getAttribute('data-handle')
    this.collections = window[`collectionScrollConfig${this.indexSection}`]
    this.gridItems = this.querySelector('.js-collection-grid-scroll')
    this.headerCustom = this.querySelector('.js-section-header-custom')
    this.scrollLoading = this.querySelector('.js-collection-scrol-loading')

    this.isFetching = false
  }

  async fetchDataProducts() {
    if (this.handleCollection && !this.isFetching) {
      this.isLoading(true)
      this.isFetching = true

      setTimeout(async () => {
        try {
          const result = await fetch(`/collections/${this.handleCollection}?view=ajax`).then((response) => {
            if (response.status >= 200 && response.status <= 299) {
              return response.json()
            }
          }).then((jsonResponse) => {
            return jsonResponse
          })
  
          if (result?.products.length > 0) {
            let html = '';
    
            result.products.forEach(product => {
              html += `
                <div class="grid__item">
                  <a href=${product.url} class="grid-link" alt="${product.title}">
                    <span class="grid-link__image grid-link__image--product">
                      <span class="grid-link__image-centered">
                        <img src="${product.featuredImage}" alt=${product.title} />
                      </span>
                    </span>
                  </a>
                </div>
              `
            })
            this.gridItems.innerHTML += html
  
            if (this.headerCustom) {
              this.headerCustom.style.display = 'block'
            }
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.isLoading(false)
          this.isFetching = false
        }
      }, 1500)
    }
  }

  isLoading(status) {
    if (this.scrollLoading) {
      if (status) {
        this.scrollLoading.classList.add('loading')
      } else {
        this.scrollLoading.classList.remove('loading')
      }
    }
  }
}

customElements.define('collection-scroll', CollectionScroll)

const collectionScrolls = document.querySelectorAll('collection-scroll');
let loadedIndex = 0;
let isFetchingProduct = false

async function handleScroll() {
    if (loadedIndex >= collectionScrolls.length) return

    if (!isFetchingProduct) {
      const currentCollection = collectionScrolls[loadedIndex - 1]
      const gridItems = currentCollection?.querySelector('.js-collection-grid-scroll')
      
      if (!gridItems || gridItems.childNodes.length === 0) return
  
      const lastProduct = gridItems.lastElementChild
  
      if (lastProduct && isElementInViewport(lastProduct)) {
          await loadProducts()
      }
    }

}

async function loadProducts() {
    if (loadedIndex >= collectionScrolls.length) return

    const element = collectionScrolls[loadedIndex]

    isFetchingProduct = true
    await element.fetchDataProducts()

    loadedIndex++
    isFetchingProduct = false
}

function isElementInViewport(el) {
    const rect = el.getBoundingClientRect()
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight + 10 || document.documentElement.clientHeight + 10) &&
        rect.right <= (window.innerWidth + 10 || document.documentElement.clientWidth + 10)
    )
}

window.onload = () => {
    loadProducts()
}

window.addEventListener('scroll', handleScroll)

// Collection Template Scroll
// const totalPage = collectionConfig.totalPagination
const totalPage = Math.ceil(collectionConfig.totalProduct / 40) //mới
const totalProduct = collectionConfig.totalProduct

const currentUrl = new URL(window.location.href)
const currentPage = currentUrl.searchParams.get('page')

const gridCollection = document.querySelector('.js-collection-grid')
const wrapperGrid = document.querySelector('.collection-wrapper')

const fetchAjaxProduct = async (url, page) => {
  const currentURL = url || window.location.href
  try {
    const response = await fetch(`${currentURL}&view=scroll&page=${page}`);
    if (response.status >= 200 && response.status <= 299) {
      const jsonResponse = await response.json();
      return jsonResponse;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
  }
};

const getProductPerPage = async (url, page) => {
  const result = await fetchAjaxProduct(url, page)

  console.log(result)

  if (result?.products.length > 0) {
    let newHtml = '';

    result.products.forEach(product => {
      newHtml += `
        <div class="grid__item" data-page="${page}">
          <a href=${product.url} class="grid-link" alt="${product.title}">
            <span class="grid-link__image grid-link__image--product">
              <span class="grid-link__image-centered">
                <img src="${product.featuredImage}" alt=${product.title} />
              </span>
            </span>
          </a>
        </div>
      `
    })

    return newHtml
  }
}

const loadNewPage = async (page) => {
  try {
    isLoadingCollection(true);
    isFetchingProduct = true;

    setTimeout(async () => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('page', page);
      const url = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', url);

      const newPage = await getProductPerPage('', page);
      if (!newPage) {
        isLoadingCollection(false);
        isFetchingProduct = false;
        return;
      }

      gridCollection.innerHTML = gridCollection.innerHTML + newPage;
      isLoadingCollection(false);
      isFetchingProduct = false;
    }, 1500);
  } catch (error) {
    isLoadingCollection(false);
    isFetchingProduct = false;
  }
};


const handleScrollCollection = async () => {
  if (isFetchingProduct) {
    return
  }

  const gridItems = document.querySelector('.js-collection-grid')

  if (!gridItems || gridItems.childNodes.length === 0) {
    return
  }

  const lastItem = gridItems.lastElementChild

  if (lastItem && isElementInViewport(lastItem)) {
    const currentPage = lastItem.getAttribute('data-page')

    if (currentPage < totalPage) {
      await loadNewPage(parseInt(currentPage) + 1)
    }
  }
}

const initProductCollection = async () => {
  // let page = parseInt(currentPage) ? (parseInt(currentPage) >= 3 ? 3 : parseInt(currentPage)) : 1
  let page = parseInt(currentPage) || 1 //mới

  if (page <= 1) {
    return
  }

  isLoadingCollection(true)
  isFetchingProduct = true

  let html = ''
  for (let i = 1; i <= page; i++) {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set('page', i)
    const url = window.location.pathname + '?' + searchParams.toString()
    history.pushState(null, '', url);

    const newPage = await getProductPerPage(url, i)
    
    html += newPage
  }

  gridCollection.innerHTML = html

  isLoadingCollection(false)

  setTimeout(() => {
    isFetchingProduct = false
  }, 1500)
}

const isLoadingCollection = (state) => {
  if (!wrapperGrid) {
    return
  }

  if (state) {
    wrapperGrid.classList.add('loading')
  } else {
    wrapperGrid.classList.remove('loading')
  }
}

window.onload = () => {
  if (gridCollection) {
    initProductCollection()
  }
}

window.addEventListener('scroll', handleScrollCollection)

// Sort express search by created-descending
const expressSearchForm = document.querySelector('.express-search__form')
if (expressSearchForm) {
  expressSearchForm.addEventListener('submit', function(e) {
    e.preventDefault()
    const params = new URLSearchParams(new FormData(this))
    params.set('sort_by', 'created-descending')
    window.location.href = '/collections/all?' + params.toString()
  })
}